import { AlertCircle } from 'lucide-react';

type FieldErrorProps = {
  id?: string;
  testId?: string;
  tone?: 'error' | 'warning';
  children: string;
};

const TONE_CLASS = {
  error: 'text-error-600',
  warning: 'text-warning-700',
} as const;

export function FieldError({
  id,
  testId,
  tone = 'error',
  children,
}: Readonly<FieldErrorProps>) {
  return (
    <div
      id={id}
      data-testid={testId}
      role="alert"
      className={`flex items-start gap-1 text-xs ${TONE_CLASS[tone]}`}
    >
      <AlertCircle size={14} className="mt-px shrink-0" aria-hidden />
      {children}
    </div>
  );
}
